<template>
  <TheHeader v-if="!$route.meta.hideLayout"/>
  
  <main>
    <router-view />
  </main>
  
  <TheFooter v-if="!$route.meta.hideLayout"/>
  <WhatsAppButton v-if="!$route.meta.hideLayout"/>
</template>

<script setup lang="ts">
import TheHeader from './components/layout/Header.vue';
import TheFooter from './components/layout/Footer.vue';
import WhatsAppButton from './components/layout/WhatsAppButton.vue'; // Verifique este import


</script>

<style>
/* Estilos Globais e Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif; /* Ou sua fonte de preferência */
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Garante que o footer fique no fundo se a página for curta */
}

.main-content {
  flex: 1; /* Faz esta área crescer para ocupar o espaço entre header e footer */
}

/* Transição suave entre as trocas de página */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>